var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3594_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.26 8.59H13.7V0.63C13.7 0.28 13.42 0 13.07 0H0.63C0.28 0 0 0.28 0 0.63V22.36C0 22.71 0.28 22.99 0.63 22.99H21.26C21.61 22.99 21.89 22.71 21.89 22.36V9.22C21.89 8.87 21.61 8.59 21.26 8.59ZM20.58 9.86V21.74H13.7V9.86H20.58ZM8.69 18.37V21.74H4.97V18.37H8.69ZM9.32 17.11H4.34C3.99 17.11 3.71 17.39 3.71 17.74V21.74H1.32V1.26H12.39V9.07C12.38 9.13 12.37 9.18 12.37 9.22V21.73H9.95V17.73C9.95 17.38 9.67 17.1 9.32 17.1V17.11Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95014 3.41016H4.23014C4.04014 3.41016 3.89014 3.55016 3.89014 3.73016V5.72016C3.89014 5.90016 4.04014 6.04016 4.23014 6.04016H4.95014C5.14014 6.04016 5.29014 5.90016 5.29014 5.72016V3.73016C5.29014 3.55016 5.14014 3.41016 4.95014 3.41016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41986 3.41016H8.69986C8.50986 3.41016 8.35986 3.55016 8.35986 3.73016V5.72016C8.35986 5.90016 8.50986 6.04016 8.69986 6.04016H9.41986C9.60986 6.04016 9.75986 5.90016 9.75986 5.72016V3.73016C9.75986 3.55016 9.60986 3.41016 9.41986 3.41016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95014 7.95996H4.23014C4.04014 7.95996 3.89014 8.09996 3.89014 8.27996V10.27C3.89014 10.45 4.04014 10.59 4.23014 10.59H4.95014C5.14014 10.59 5.29014 10.45 5.29014 10.27V8.27996C5.29014 8.09996 5.14014 7.95996 4.95014 7.95996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41986 7.95996H8.69986C8.50986 7.95996 8.35986 8.09996 8.35986 8.27996V10.27C8.35986 10.45 8.50986 10.59 8.69986 10.59H9.41986C9.60986 10.59 9.75986 10.45 9.75986 10.27V8.27996C9.75986 8.09996 9.60986 7.95996 9.41986 7.95996Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95014 12.5H4.23014C4.04014 12.5 3.89014 12.64 3.89014 12.82V14.81C3.89014 14.99 4.04014 15.13 4.23014 15.13H4.95014C5.14014 15.13 5.29014 14.99 5.29014 14.81V12.82C5.29014 12.64 5.14014 12.5 4.95014 12.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41986 12.5H8.69986C8.50986 12.5 8.35986 12.64 8.35986 12.82V14.81C8.35986 14.99 8.50986 15.13 8.69986 15.13H9.41986C9.60986 15.13 9.75986 14.99 9.75986 14.81V12.82C9.75986 12.64 9.60986 12.5 9.41986 12.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 14.7799H17.4702C17.6602 14.7799 17.8102 14.6399 17.8102 14.4599V12.4699C17.8102 12.2899 17.6602 12.1499 17.4702 12.1499H16.7502C16.5602 12.1499 16.4102 12.2899 16.4102 12.4699V14.4599C16.4102 14.6399 16.5602 14.7799 16.7502 14.7799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 19.4298H17.4702C17.6602 19.4298 17.8102 19.2898 17.8102 19.1098V17.1198C17.8102 16.9398 17.6602 16.7998 17.4702 16.7998H16.7502C16.5602 16.7998 16.4102 16.9398 16.4102 17.1198V19.1098C16.4102 19.2898 16.5602 19.4298 16.7502 19.4298Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3594_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9,
    height: 22.99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.114bd890815dd06e3be2dab3d3311977.svg";
export { ForwardRef as ReactComponent };